// extracted by mini-css-extract-plugin
var _1 = "RequestProfile-modulecontent__YAU4Q PageWithWidgets-modulecontent__b10rn";
var _2 = "RequestProfile-modulestickyTitle__Y_hvm";
export { _1 as "content", _2 as "stickyTitle" }
